/* eslint-disable react/no-array-index-key */
import classNames from 'classnames';
import PropTypes from 'prop-types';
import React from 'react';
import { FormattedMessage } from 'react-intl';

import { getImageAtSize } from '../../lib/utils';

import styles from '../../../styles/partials/floating-cta.module.css';

const propTypes = {
    image: PropTypes.shape({}),
    className: PropTypes.string,
};

function FloatingCta({ image = null, className }) {
    const { url = null } = getImageAtSize(image, 'large') || {};
    return (
        <a
            href="https://projections.tenk.ca/fr/bibliotheques"
            className={classNames([styles.container, { [className]: className !== null }])}
            style={{ backgroundImage: url !== null ? `url('${url}')` : url }}
        >
            <div className={styles.circle}>
                <p className={styles.title}>
                    <FormattedMessage
                        defaultMessage="Want to schedule a projection?"
                        description="CTA title"
                    />
                </p>
                <hr className={styles.spacer} />
                <p className={styles.description}>
                    <FormattedMessage
                        defaultMessage="Use our platform to schedule one in your library today!"
                        description="CTA description"
                    />
                </p>
            </div>
        </a>
    );
}

FloatingCta.propTypes = propTypes;

export default FloatingCta;
